
import {defineComponent, onMounted, computed} from 'vue'
import {useRoute} from 'vue-router'
import {useVoucherStore} from '@/stores/voucher/voucher-store'
import SVoucherCard from '@/views/voucher/SVoucherCard.vue'
import {useMasterStore} from '@/stores/master-store'
import {useGlobalStore} from '@/stores/global-store'
import {isApiError} from '@/services/api.v1/common/api-service'

export default defineComponent({
  components: {
    SVoucherCard,
  },
  props: {},
  setup() {
    const route = useRoute()
    const {fetchVouchersByCategoryId, vouchers} = useVoucherStore()
    const {fetchVoucherCategories, voucherCategories} = useMasterStore()
    const {isLoading, startLoading, endLoading} = useGlobalStore()

    const categoryId = Number(route.params.categoryId as string)

    onMounted(async () => {
      try {
        await fetchVouchersByCategoryId({offset: 0, limit: 5, categoryId})
        await fetchVoucherCategories()
      } catch (e) {
        if (!isApiError(e)) {
          throw e
        }
      }
      document.title = vouchers.value.data[0]?.categories[0]?.name ?? 'カテゴリ'
    })

    const voucherCategory = computed(() => {
      return voucherCategories.value.find(
        (e) => e.voucherCategoryId === categoryId,
      )
    })

    const loadMoreVouchers = async () => {
      try {
        startLoading()
        await fetchVouchersByCategoryId({
          offset: vouchers.value.data.length,
          limit: 5,
          categoryId,
        })
      } catch (e) {
        if (!isApiError(e)) {
          throw e
        }
      } finally {
        endLoading()
      }
    }

    return {
      vouchers,
      voucherCategory,
      loadMoreVouchers,
      isLoading,
    }
  },
})
